import { memo } from 'react';

type Props = {
  className?: string;
  size?: number;
};

export const QuantAnalysis = memo(({ className, size = 24 }: Props) => (
  <svg
    className={className}
    width={size}
    height={size * 25 / 24}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
      <g transform="translate(3.000000, 5.000000)" stroke="#686868" strokeLinejoin="round" strokeWidth="1.5">
        <rect x="0" y="0" width="18" height="15" rx="1"></rect>
      </g>
      <line x1="12.25" y1="18.75" x2="12.25" y2="1.25" stroke="#686868" strokeWidth="1.5" transform="translate(12.250000, 10.000000) rotate(-270.000000) translate(-12.250000, -10.000000)" />
      <line x1="8" y1="20" x2="8" y2="5" stroke="#686868" strokeWidth="1.5" />
    </g>
  </svg>
));

export default QuantAnalysis;